export default __webpack_public_path__ + "static/media/Gloves of the Death Master.99a9f53f.jpg";